import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import type { PlanIntervals } from "@circle-react/helpers/plansHelpers";
import { planIntervals } from "@circle-react/helpers/plansHelpers";
import { useQueryParamChange } from "@circle-react/hooks/useQueryParamChange";
import { BadgeV2 } from "@circle-react-uikit/BadgeV2";

interface BillingCycleLinkProps {
  interval: PlanIntervals;
  isSelected: (interval: PlanIntervals) => boolean;
  label: string;
}

export const BillingCycleLink = ({
  interval,
  isSelected,
  label,
}: BillingCycleLinkProps) => {
  const handleQueryParamChange = useQueryParamChange();
  const selectedClass = isSelected(interval)
    ? "bg-primary !text-dark "
    : "text-tertiary";

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    handleQueryParamChange("billing_cycle", interval);
  };

  const shouldShowAnnualDiscount = interval === planIntervals.year;

  return (
    <button
      onClick={handleClick}
      className={classNames(
        "hover:text-darkest text-tertiary shadow-xs flex flex-row rounded-lg px-2 py-1 text-center align-baseline font-medium",
        selectedClass,
      )}
      aria-pressed={isSelected(interval)}
      type="button"
    >
      {label}
      {shouldShowAnnualDiscount && (
        <BadgeV2
          square
          label={t("pricing_plans.billing_cycle.annual_discount")}
          className="ml-2 !border-none !bg-[#22C55E1A] !text-[#15803D]"
        />
      )}
    </button>
  );
};
